/**
 * How far one press seeks, the same everywhere: the seek bar's Left/Right and
 * the remote's rewind/fast-forward. TiviMate's steps — back a little to catch
 * what was missed, forward further to skip.
 */
export const SEEK_BACK_S = 10;
export const SEEK_FORWARD_S = 30;
